import contactPattern from "app/assets/images/contact-us/Contact Us Patten ------.jpg";
import {
  ContactForm,
  ContactMap,
  ContactMethods,
} from "~/modules/contact-us/components";
import { SubscribeToOurNewsletter } from "~/modules/home/components";

export function ContactUsPage() {
  return (
    <>
      <div className="relative">
        <img
          src={contactPattern}
          alt="contact"
          className="absolute -z-10 object-cover w-full h-full"
        />
        <div className="container">
          <div className="flex flex-col gap-[5.375rem] py-[4.5rem]">
            <ContactMethods />
            <ContactForm />
            <ContactMap />
          </div>
        </div>
      </div>
      <SubscribeToOurNewsletter />
    </>
  );
}
